import { m8API } from 'services/production/m8';
import { CancelGiroPaymentService } from 'types/services';

export const cancelGiroPayment: CancelGiroPaymentService = async (params) => {
  await m8API.admin.setStatementAsFailed({
    idStatement: params.giroPaymentId,
  });
};
